import { ActualizarPreguntaME } from './../../../open-api/model/actualizarPreguntaME';
import { AdicionarPreguntaME } from './../../../open-api/model/adicionarPreguntaME';
import { PreguntaService } from './../../../open-api/api/pregunta.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-nueva-pregunta',
  templateUrl: './nueva-pregunta.component.html',
  styleUrls: ['./nueva-pregunta.component.scss']
})
export class NuevaPreguntaComponent implements OnInit {

  @Input() title = '';
  @Input() pregunta?: string;
  @Input() preguntaId?: number;

  constructor(
    public activeModal: NgbActiveModal,
    private preguntaService: PreguntaService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
  }

  Aceptar(): void {
    this.spinner.show();
    if (this.title === 'Nueva') {
      const parametro: AdicionarPreguntaME = {
        descripcion: this.pregunta
      };
      this.preguntaService.apiV10PreguntaPost(parametro).subscribe(resultado => {
        this.spinner.hide();
        this.activeModal.close('Aceptar');
      });
    } else {
      const parametro: ActualizarPreguntaME = {
        descripcion: this.pregunta,
        id: this.preguntaId,
        estaActivo: true
      };
      this.preguntaService.apiV10PreguntaActualizarPreguntaPost(parametro).subscribe(resultado => {
        this.spinner.hide();
        this.activeModal.close('Aceptar');
      });
    }

  }
}
